const url = process.env?.REACT_APP_URL;
console.log("url", url);

const handleBaseUrl = () => {
  switch (url) {
    case "stage":
      return "https://31zrjt6fa6.execute-api.us-west-2.amazonaws.com/stageCampaignInterface/";
    default:
      return "https://0k800v9vuk.execute-api.us-west-2.amazonaws.com/productionCampaignInterface/";
  }
};
const handleXamplifierBaseUrl = () => {
  switch (url) {
    case "stage":
      return "https://stage.api.config.layline.live/api/";
    default:
      return "https://api.config.layline.live/api/";
  }
};

const handlePermissionUrl = () => {
  switch (url) {
    case "stage":
      return "https://stage.layline.live/api/user-permissions";
    default:
      return "https://insights.layline.live/api/user-permissions";
  }
};

const handleChangeUrl = () => {
  switch (url) {
    case "stage":
      return {
        setter: "https://stage.setter.layline.live/",
        listing: "https://stage.layline.live/listings",
        reputation:
          "https://stage.layline.live/dashboards/rep-summary/reputation",
        patientExperience:
          "https://stage.layline.live/dashboards/customer-experience/nps-overview",
        config: "https://stage.config.layline.live/",
        access: "https://dev.access.layline.live/login",
        layline: "https://stage.layline.live/welcome",
        forget: "https://stage.layline.live/password/reset",
        campaign: "https://stage.campaigns.layline.live/",
      };
    default:
      return {
        setter: "https://setter.layline.live/",
        listing: "https://listings.layline.live/listings",
        reputation:
          "https://insights.layline.live/dashboards/rep-summary/reputation",
        patientExperience:
          "https://insights.layline.live/dashboards/customer-experience/nps-overview",
        config: "https://config.layline.live/",
        access: "https://access.layline.live/",
        layline: "https://insights.layline.live/",
        forget: "https://insights.layline.live/password/reset",
        campaign: "https://campaigns.layline.live/",
      };
  }
};

export const BASE_URL = handleBaseUrl();
export const XAMPLIFIER_BASE_URL = handleXamplifierBaseUrl();
export const DOMAIN_NAME = handleChangeUrl();
export const PERMISSION_URL = handlePermissionUrl();
